import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import { selectLoan } from '../../reducers'
import { Sidebar } from './sidebar'
import { fetchLoan, updateLoan } from './underwritingActions'
import { UnderwritingLoanApp } from './loanApp'
import { UnderwritingDecisionHistory } from './decisionHistory'
import { UnderwritingTradelineSummary } from './tradelineSummary'
import { UnderwritingRules } from './rules'
import { UnderwritingCreditReport } from './creditReport'
import { Loan, AdverseActionReason } from './types'
import { approveTask, rejectTask } from '../tasks/taskActions'

export type Callback<T = void> = (...args: any) => T
export interface Match<T> {
  params: T
}

export interface ParamsID {
  id: string
}

export interface Props {
  fetchLoan: Callback
  loan: Loan
  match: Match<ParamsID>
  approveTask: Callback<Promise<any>>
  rejectTask: Callback<Promise<any>>
  history: History
  location: Location
  adverseActionReasons: AdverseActionReason[]
  updateLoan: Callback
}

export class UnderwritingShow extends Component<Props> {
  componentWillMount() {
    this.fetchLoanData()
  }

  componentDidUpdate(prevProps: Props) {
    const { match } = this.props

    if (match.params.id !== prevProps.match.params.id) {
      this.fetchLoanData()
    }
  }

  approve = (ofacTask, adminNote) => {
    const { approveTask } = this.props
    return approveTask(ofacTask.id, adminNote).then(() => {
      window.location.reload()
    })
  }

  reject = (ofacTask, adminNote) => {
    const { rejectTask } = this.props
    if (window.confirm(`Confirm ${ofacTask.taskType} rejection`)) {
      return rejectTask(ofacTask.id, adminNote, 'HARD').then(() => {
        window.location.reload()
      })
    } else {
      return null
    }
  }

  onSubmit =
    (ofacTask) =>
    ({ adminNote, accept }) => {
      if (accept) {
        return this.approve(ofacTask, adminNote)
      } else {
        return this.reject(ofacTask, adminNote)
      }
    }

  pageTitle = {
    rules: 'Policy and Rules',
    tradelines: 'TradeLine Summary',
    'loan-app': 'Loan Application',
    'credit-report': 'Credit Report',
    history: 'Decision History',
  }

  extractPageName = (path) => {
    return path.match(/.*\/(.*)$/)[1]
  }

  renderContent = (extension, component) => {
    let { pathname } = this.props.location
    let Component = component
    let path = this.extractPageName(pathname)
    if (path === extension) {
      return <Component {...this.props} />
    } else return null
  }

  fetchLoanData = () => {
    const { fetchLoan, match } = this.props
    fetchLoan(match.params.id)
  }

  LoanApp = () => (
    <UnderwritingLoanApp
      fetchLoan={this.props.fetchLoan}
      loan={this.props.loan}
      updateLoan={this.props.updateLoan}
      adverseActionReasons={this.props.adverseActionReasons}
    />
  )
  TradeLine = () => (
    <UnderwritingTradelineSummary
      fetchLoan={this.props.fetchLoan}
      loan={this.props.loan}
      updateLoan={this.props.updateLoan}
    />
  )

  render() {
    const { loan } = (this.props || {}) as Partial<NonNullable<Props>>
    let { pathname } = this.props.location
    let path = this.extractPageName(pathname)
    if (!loan || !loan.id) return null
    return (
      <div className="underwriting">
        <h1>{this.pageTitle[path]}</h1>
        <div className="underwriting--wrapper">
          <Sidebar loan={loan} activeSection={path} onSubmit={this.onSubmit} />
          <div className="content">
            <Router>
              <div>
                {this.renderContent('loan-app', UnderwritingLoanApp)}
                {this.renderContent('tradelines', UnderwritingTradelineSummary)}
                {this.renderContent('history', UnderwritingDecisionHistory)}
                {this.renderContent('credit-report', UnderwritingCreditReport)}
                {this.renderContent('rules', UnderwritingRules)}
              </div>
            </Router>
          </div>
        </div>
      </div>
    )
  }
}

export const mapStateToProps = (state: { loans: any }, { match }: Props) => {
  return {
    loan: selectLoan(state.loans, match.params && match.params.id),
    adverseActionReasons: state.loans.adverseActions.reasons,
  }
}

export default withRouter(
  connect(mapStateToProps, {
    fetchLoan,
    updateLoan,
    approveTask,
    rejectTask,
  })(UnderwritingShow)
)
